import { styled } from "@mui/material";
import { Box } from "@mui/material";

export const Centered = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
});
